<template>
  <div
    style="color: black; z-index: 1;  top: 0; left: 0; right: 0; bottom: 0 "
    :style="{
      position: inline == true ? 'initial' : 'absolute',
      'background-color': backgroundColor
    }"
  >
    <v-layout fill-height column justify-center>
      <div
        class="text-xs-center mt-4"
        style="margin-bottom: 25px;"
        :style="{ 'margin-top': marginTop + 'px' }"
        ref="premiumLock"
      >
        <img src="/static/img/assets/icon/z-12.png" alt style="width: 100%; max-width: 100px" />
        <img
          v-if="showAll"
          src="/static/img/assets/setting/premium_alert.png"
          alt
          style="width: 100%; max-width: 300px"
        />
        <h1 style="text-shadow: 1px 1px 20px #9e9e9e;" v-if="size == 'big'" class="mb-2">
          {{ $t('Its time to upgrade.') }}
        </h1>
        <h2 style="text-shadow: rgb(255, 105, 105) 1px 1px 20px;" v-else>
          {{ $t('Its time to upgrade.') }}
        </h2>
        <template v-if="selectedBot.pagetype != 'enterprise'">
          <div class="wrapper--text-package">
            <p class="text-package" style="">
              {{
                text === ''
                  ? $t('Upgrade Your Plan to use {package} features , only {price} THB/month', {
                      price: packages.premium.price,
                      package: $t('PREMIUM')
                    })
                  : $t(text)
              }}
            </p>
          </div>

          <v-btn
            depressed
            style="margin-bottom:1.5em"
            :to="'/' + $i18n.locale() + '/upgrade'"
            small
            color="primary"
            >{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</v-btn
          >
        </template>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    showAll: {
      default: true
    },
    inline: {
      default: false
    },
    marginTop: {
      default: 0
    },
    backgroundColor: {
      default: '#ecececbd'
    },
    size: {
      default: 'big'
    },
    text: {
      default: ''
    }
  },
  data() {
    return {
      packages: this.getPackageDetail()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style scoped>
.wrapper--text-package {
  width: 50%;
  margin: auto;
}

.text-package {
  text-shadow: rgb(80, 80, 80) 1px 1px 20px;
}

@media screen and (max-width: 768px) {
  .wrapper--text-package {
    width: 100%;
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/PremiumPlanPopup.vue